import React from "react";
import styles from "./CartIcon.module.css";

function CartIcon() {
  return (
    <svg
      className={styles["icon"]}
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 497.945 497.945"
      version="1.1"
      viewBox="0 0 497.945 497.945"
      xmlSpace="preserve"
    >
      <path
        fill="#FFCA19"
        d="M431.543 335.281L482.743 96.836 90.697 96.836 147.749 335.281z"
      ></path>
      <path
        fill="#E9AE21"
        d="M482.743 96.836L90.697 96.836 99.474 134.87 471.04 134.87z"
      ></path>
      <path d="M431.543 351.373H147.749c-7.314 0-13.166-4.389-14.629-11.703L76.069 99.761c-1.463-4.389 0-8.777 2.926-11.703s7.314-5.851 11.703-5.851h392.046c4.389 0 8.777 1.463 11.703 5.851 2.926 2.926 4.389 8.777 2.926 13.166l-51.2 236.983c-1.464 7.314-7.316 13.166-14.63 13.166zm-272.092-30.72H419.84l43.886-209.189H109.714l49.737 209.189z"></path>
      <path d="M90.697 111.464c-7.314 0-13.166-4.389-14.629-11.703L64.366 57.338H14.629C5.851 57.338 0 50.024 0 42.71s7.314-14.629 14.629-14.629h61.44c7.314 0 13.166 4.389 14.629 11.703l14.629 54.126c1.463 7.314-2.926 14.629-10.24 17.554h-4.39zM416.914 425.978H99.474c-29.257 0-52.663-23.406-52.663-52.663s23.406-52.663 52.663-52.663h317.44c8.777 0 14.629 7.314 14.629 14.629 0 7.314-7.314 14.629-14.629 14.629H99.474c-13.166 0-23.406 10.24-23.406 23.406s10.24 23.406 23.406 23.406h317.44c8.777 0 14.629 7.314 14.629 14.629 1.463 8.776-5.852 14.627-14.629 14.627z"></path>
      <circle cx="383.269" cy="412.813" r="42.423" fill="#C0D0D6"></circle>
      <circle cx="383.269" cy="412.813" r="14.629" fill="#849DA9"></circle>
      <path d="M383.269 469.864c-32.183 0-58.514-26.331-58.514-58.514s26.331-58.514 58.514-58.514 58.514 26.331 58.514 58.514-26.332 58.514-58.514 58.514zm0-84.846c-16.091 0-27.794 13.166-27.794 27.794 0 16.091 13.166 27.794 27.794 27.794s27.794-13.166 27.794-27.794c0-16.091-13.166-27.794-27.794-27.794z"></path>
      <circle cx="150.674" cy="412.813" r="42.423" fill="#C0D0D6"></circle>
      <circle cx="150.674" cy="412.813" r="14.629" fill="#849DA9"></circle>
      <path d="M150.674 469.864c-32.183 0-58.514-26.331-58.514-58.514s26.331-58.514 58.514-58.514 58.514 26.331 58.514 58.514-26.331 58.514-58.514 58.514zm0-84.846c-16.091 0-27.794 13.166-27.794 27.794 0 16.091 13.166 27.794 27.794 27.794s27.794-13.166 27.794-27.794c.001-16.091-11.702-27.794-27.794-27.794zM219.429 266.527c-8.777 0-14.629-7.314-14.629-14.629V165.59c0-8.777 7.314-14.629 14.629-14.629 8.777 0 14.629 7.314 14.629 14.629v86.309c-.001 8.777-5.852 14.628-14.629 14.628zM286.72 266.527c-8.777 0-14.629-7.314-14.629-14.629V165.59c0-8.777 7.314-14.629 14.629-14.629 8.777 0 14.629 7.314 14.629 14.629v86.309c0 8.777-5.852 14.628-14.629 14.628zM354.011 266.527c-8.777 0-14.629-7.314-14.629-14.629V165.59c0-8.777 7.314-14.629 14.629-14.629 8.777 0 14.629 7.314 14.629 14.629v86.309c0 8.777-5.851 14.628-14.629 14.628z"></path>
    </svg>
  );
}

export default CartIcon;
